import React from "react";

const ContentDescriptionInput = ({ ec, option, register }) => {
  return (
    <>
      <textarea
        {...register(`mc-${ec[0].id}-${option.id}`, {
          value: ec[1].description,
          shouldUnregister: true,
        })}
      />
      {/* Errors? */}
    </>
  );
};

export default ContentDescriptionInput;
